import { peek, selector } from 'lib/selectors'
import { StateInterface } from 'types/state'

const certification = (state: StateInterface) => state.certification
export const certificationsListSelector = selector(certification, peek('certificationsList'))
export const certificationSelector = selector(certification, peek('certification'))
